import React from 'react'
import SuccessMessageUI from '../../../widgets/form/SuccessMessageUI'
import ErrorMessage2UI from '../../../widgets/form/ErrorMessage2UI'
import ModalUI from '../../../widgets/layout/ModalUI'
import './LoanTypeAndEventMappingEditModal.css'

const LoanTypeAndEventMappingEditModalUI = ({
  context,
  messageList,
  successMsg,
  errorList,
  setErrorList,
  
  editMode,
  submitted,
  
  whatsappTemplateId,
  onWhatsappTemplateIdChange,
  whatsappTemplateIdError,
  setWhatsappTemplateIdError,
  
  emailTemplateId,
  onEmailTemplateIdChange,
  emailTemplateIdError,
  setEmailTemplateIdError,
  
  positiveWhatsappTemplateId,
  onPositiveWhatsappTemplateIdChange,
  positiveWhatsappTemplateIdError,
  setPositiveWhatsappTemplateIdError,
  
  negativeWhatsappTemplateId,
  onNegativeWhatsappTemplateIdChange,
  negativeWhatsappTemplateIdError,
  setNegativeWhatsappTemplateIdError,
  
  positiveEmailTemplateId,
  onPositiveEmailTemplateIdChange,
  positiveEmailTemplateIdError,
  setPositiveEmailTemplateIdError,
  
  negativeEmailTemplateId,
  onNegativeEmailTemplateIdChange,
  negativeEmailTemplateIdError,
  setNegativeEmailTemplateIdError,
  
  status,
  onStatusChange,
  statusError,
  setStatusError,
  
  isEnabled,
  onMapEventChange,
  
  sequence,
  onSequenceChange,
  
  // Templates
  whatsappTemplates = [],
  emailTemplates = [],
  loadingTemplates = false,
  loadingEmailTemplates = false,
  
  onSubmit,
  onCancelClick
}) => {

  console.log('whatsappTemplates', whatsappTemplates)
  console.log('emailTemplates', emailTemplates)
  // Generate WhatsApp template options from the fetched templates
  const whatsappTemplateOptions = whatsappTemplates.map(template => ({
    value: template.whatsappTemplateId,
    label: template.name || template.whatsappTemplateId
  }));
  
  console.log('whatsappTemplateOptions', whatsappTemplateOptions)
  // Generate Email template options from the fetched templates
  const emailTemplateOptions = emailTemplates.map(template => ({
    value: template.emailTemplateId,
    label: template.name || template.emailTemplateId
  }));
  console.log('emailTemplateOptions', emailTemplateOptions)
  
  // Use the default options if no templates are fetched yet
  const defaultWhatsappOptions = [
    { value: '001', label: '001' },
    { value: '01', label: '01' },
    { value: '212', label: '212' },
    { value: '10001', label: '10001' },
    { value: '2', label: '2' },
    { value: '3', label: '3' }
  ];

  const defaultEmailOptions = [
    { value: '59082a4a-0b27-41fc-84f2-24232f82fee4', label: 'Welcome Email' },
    { value: 'email-001', label: 'Notification Email' },
    { value: 'email-002', label: 'Reminder Email' }
  ];
  
  // Use template options or fall back to defaults if empty
  const whatsappOptions = whatsappTemplateOptions.length > 0 ? whatsappTemplateOptions : defaultWhatsappOptions;
  const emailOptions = emailTemplateOptions.length > 0 ? emailTemplateOptions : defaultEmailOptions;

  const sequenceOptions = [
    { value: '1', label: '1' },
    { value: '2', label: '2' },
    { value: '3', label: '3' },
    { value: '4', label: '4' },
    { value: '5', label: '5' }
  ];

  return (
    <ModalUI
      isOpen={editMode}
      onRequestClose={onCancelClick}
      context={context}
    >
      {/* <div className="g_modal_header">
        <h2 className="g_modal_title">Edit</h2>
      </div> */}
      
      <div className="g_modal_body edit-modal-body">
        <form onSubmit={onSubmit}>
          <SuccessMessageUI successMsg={successMsg} />
          <ErrorMessage2UI errorMessages={errorList} />
          
          <div className="g_form_group">
            <label htmlFor="whatsappTemplateId">WhatsApp Template Id</label>
            <select
              id="whatsappTemplateId"
              className="g_input"
              value={whatsappTemplateId}
              onChange={onWhatsappTemplateIdChange}
              disabled={submitted}
            >
              <option value="">Select Template</option>
              {loadingTemplates ? (
                <option disabled>Loading templates...</option>
              ) : (
                whatsappTemplateOptions.map(option => (
                  <option key={option.value} value={option.value}>{option.label}</option>
                ))
              )}
            </select>
            <ErrorMessage2UI errorMessage={whatsappTemplateIdError} />
          </div>
          
          <div className="g_form_group">
            <label htmlFor="emailTemplateId">Email Template Id</label>
            <select
              id="emailTemplateId"
              className="g_input"
              value={emailTemplateId}
              onChange={onEmailTemplateIdChange}
              disabled={submitted}
            >
              <option value="">Select Template</option>
              {emailTemplateOptions.map(option => (
                <option key={option.value} value={option.value}>{option.label}</option>
              ))}
            </select>
            <ErrorMessage2UI errorMessage={emailTemplateIdError} />
          </div>
          
          <div className="g_form_group">
            <label htmlFor="positiveWhatsappTemplateId">Positive WhatsApp Template Id</label>
            <select
              id="positiveWhatsappTemplateId"
              className="g_input"
              value={positiveWhatsappTemplateId}
              onChange={onPositiveWhatsappTemplateIdChange}
              disabled={submitted}
            >
              <option value="">Select Template</option>
              {loadingTemplates ? (
                <option disabled>Loading templates...</option>
              ) : (
                whatsappTemplateOptions.map(option => (
                  <option key={option.value} value={option.value}>{option.label}</option>
                ))
              )}
            </select>
            <ErrorMessage2UI errorMessage={positiveWhatsappTemplateIdError} />
          </div>
          
          <div className="g_form_group">
            <label htmlFor="negativeWhatsappTemplateId">Negative WhatsApp Template Id</label>
            <select
              id="negativeWhatsappTemplateId"
              className="g_input"
              value={negativeWhatsappTemplateId}
              onChange={onNegativeWhatsappTemplateIdChange}
              disabled={submitted}
            >
              <option value="">Select Template</option>
              {loadingTemplates ? (
                <option disabled>Loading templates...</option>
              ) : (
                whatsappTemplateOptions.map(option => (
                  <option key={option.value} value={option.value}>{option.label}</option>
                ))
              )}
            </select>
            <ErrorMessage2UI errorMessage={negativeWhatsappTemplateIdError} />
          </div>
          
          <div className="g_form_group">
            <label htmlFor="positiveEmailTemplateId">Positive Email Template Id</label>
            <select
              id="positiveEmailTemplateId"
              className="g_input"
              value={positiveEmailTemplateId}
              onChange={onPositiveEmailTemplateIdChange}
              disabled={submitted}
            >
              <option value="">Select Template</option>
              {emailTemplateOptions.map(option => (
                <option key={option.value} value={option.value}>{option.label}</option>
              ))}
            </select>
            <ErrorMessage2UI errorMessage={positiveEmailTemplateIdError} />
          </div>
          
          <div className="g_form_group">
            <label htmlFor="negativeEmailTemplateId">Negative Email Template Id</label>
            <select
              id="negativeEmailTemplateId"
              className="g_input"
              value={negativeEmailTemplateId}
              onChange={onNegativeEmailTemplateIdChange}
              disabled={submitted}
            >
              <option value="">Select Template</option>
              {emailTemplateOptions.map(option => (
                <option key={option.value} value={option.value}>{option.label}</option>
              ))}
            </select>
            <ErrorMessage2UI errorMessage={negativeEmailTemplateIdError} />
          </div>
          
          <div className="g_form_group">
            <label htmlFor="sequence">Sequence</label>
            <select
              id="sequence"
              className="g_input"
              value={sequence}
              onChange={e => onSequenceChange(e.target.value)}
              disabled={submitted}
            >
              <option value="">Select Sequence</option>
              {sequenceOptions.map(option => (
                <option key={option.value} value={option.value}>{option.label}</option>
              ))}
            </select>
            <ErrorMessage2UI errorMessage={statusError} />
          </div>
          
          <div className="g_form_group toggle-group">
            <label htmlFor="mapEvent">Map Event</label>
            <div className="toggle-switch-container">
              <label className="toggle-switch">
                <input
                  type="checkbox"
                  id="mapEvent"
                  checked={isEnabled}
                  onChange={e => onMapEventChange(e.target.checked)}
                  disabled={submitted}
                />
                <span className="slider round"></span>
              </label>
            </div>
          </div>
          
          <div className="g_form_buttons_right update-btn-container">
            <button 
              type="submit" 
              className="g_button g_button_primary update-btn"
              disabled={submitted}
            >
              {submitted ? (
                <>
                  <span className="g_loader g_loader_sm g_loader_white"></span>
                  <span className="g_sr_only">Updating...</span>
                </>
              ) : 'Update'}
            </button>
          </div>
        </form>
      </div>
    </ModalUI>
  )
}

export default LoanTypeAndEventMappingEditModalUI
